/*(c) Copyright 2015 Pivotal Software, Inc. All Rights Reserved.*/
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _puiReactHelpers = require('pui-react-helpers');

var React = require('react');
var AnimationMixin = require('pui-react-animation');
var throttle = require('lodash.throttle');

var _require = require('./scroll-top');

var getScrollTop = _require.getScrollTop;
var setScrollTop = _require.setScrollTop;


var BackToTop = React.createClass({
  displayName: 'BackToTop',

  mixins: [AnimationMixin],

  propTypes: {
    alwaysVisible: React.PropTypes.bool
  },

  statics: {
    FADE_DURATION: 300,
    VISIBILITY_HEIGHT: 400,
    SCROLL_DURATION: 800
  },

  getInitialState: function getInitialState() {
    return { visible: false };
  },
  componentDidMount: function componentDidMount() {
    this.updateScroll = throttle(this.updateScroll, 100);
    window.addEventListener('scroll', this.updateScroll);
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('scroll', this.updateScroll);
  },
  updateScroll: function updateScroll() {
    this.setState({ visible: getScrollTop() > BackToTop.VISIBILITY_HEIGHT });
  },
  scrollToTop: function scrollToTop() {
    this.animate(function (value) {
      return setScrollTop(value);
    }, 0, BackToTop.SCROLL_DURATION, { startValue: getScrollTop() });
  },
  render: function render() {
    var visibleState = this.state.visible;

    var visible = this.props.alwaysVisible || visibleState;
    var props = (0, _puiReactHelpers.mergeProps)(this.props, {
      className: 'back-to-top',
      style: { display: 'inline', opacity: this.animate('opacity', visible ? 1 : 0, BackToTop.FADE_DURATION) }
    });
    return React.createElement('a', _extends({}, props, { onClick: this.scrollToTop, href: '#top', 'aria-label': 'Back to top' }));
  }
});

module.exports = { BackToTop: BackToTop };


/*****************
 ** WEBPACK FOOTER
 ** ./~/pui-react-back-to-top/back-to-top.js
 ** module id = 270
 ** module chunks = 0
 **/